module.exports = __webpack_public_path__ + "static/media/signUp.4aa0814d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage_new/images/event/signUp.png
// module id = 1259
// module chunks = 0